<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
@import "https://cdn.jsdelivr.net/npm/bulma@0.9.4/css/bulma.min.css";
  #app{
    width: 100%;
    height: 100%;
    position: absolute;
    overflow: auto;
    left: 0;
    top: 0;
  }

  body, html{
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  ul,li{
    list-style: none;
    margin: 0;
    padding: 0;
  }

  a{
    text-decoration: none;
  }

  *{
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    &:focus{
      outline: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue